/**
 * Created by roman.kupin on 11/12/2017.
 */

import * as AccountApiActions from "../../actions/accountApi";


export default function propertiesReducer(state = [], {type, payload}) {
    switch (type) {
        case AccountApiActions.PROPERTY_STATISTICS_FETCH_SUCCESS: {
            return payload;
        }
        default: {
            return state;
        }
    }
}